var map = {
	"./3d-diamond.png": 43605,
	"./3d-sphere.png": 50463,
	"./MarketArrow": 98838,
	"./MarketArrow.js": 98838,
	"./advante-team.webp": 61369,
	"./ai-metal.jpg": 67737,
	"./ai-solutions/ai-custom-solution-1.webp": 26729,
	"./ai-solutions/ai-custom-solution-2.webp": 75867,
	"./ai-solutions/ai-custom-solution-3.webp": 91462,
	"./ai-solutions/ai-custom-solution-4.webp": 61081,
	"./ai-solutions/ai-custom-solution-5.webp": 69448,
	"./ai-solutions/current-platform-1.webp": 89141,
	"./ai-solutions/current-platform-10.webp": 66619,
	"./ai-solutions/current-platform-11.webp": 95926,
	"./ai-solutions/current-platform-12.webp": 58000,
	"./ai-solutions/current-platform-13.webp": 21598,
	"./ai-solutions/current-platform-14.webp": 5387,
	"./ai-solutions/current-platform-2.webp": 56434,
	"./ai-solutions/current-platform-3.webp": 53858,
	"./ai-solutions/current-platform-4.webp": 14335,
	"./ai-solutions/current-platform-5.webp": 67224,
	"./ai-solutions/current-platform-6.webp": 42863,
	"./ai-solutions/current-platform-7.webp": 68021,
	"./ai-solutions/current-platform-8.webp": 57313,
	"./ai-solutions/current-platform-9.webp": 47919,
	"./all-nation/all-nation-app.webp": 95986,
	"./all-nation/all-nation-app2.webp": 79573,
	"./all-nation/all-nation-gradient.webp": 44837,
	"./all-nation/all-nation-phone.webp": 71716,
	"./all-nation/app-slides.webp": 35866,
	"./all-nation/city-img.webp": 53194,
	"./all-nation/code-bg.webp": 97265,
	"./all-nation/features-img.webp": 97922,
	"./all-nation/impact-bg.webp": 33721,
	"./articles/GitHub-Copilot.jpg": 36841,
	"./articles/HEX_corto.avif": 15688,
	"./articles/article-25-thumbnail.webp": 84766,
	"./articles/article-25.webp": 67700,
	"./articles/article-26-thumbnail.webp": 8,
	"./articles/article-26.webp": 61821,
	"./articles/article-27-thumbnail.webp": 73375,
	"./articles/article-27.webp": 60600,
	"./articles/article-28-thumbnail.webp": 39991,
	"./articles/article-28.webp": 27224,
	"./articles/article-29-thumbnail.webp": 37463,
	"./articles/article-29.webp": 44651,
	"./articles/article-30-thumbnail.webp": 98725,
	"./articles/article-30.webp": 89227,
	"./articles/articles-header.webp": 48417,
	"./articles/average-conversion-ratio.avif": 25127,
	"./articles/average-grades-increase.jpg": 8806,
	"./articles/aws.avif": 44586,
	"./articles/clinical-data.avif": 81289,
	"./articles/comparative.avif": 77999,
	"./articles/cough.avif": 86729,
	"./articles/coversion-rate.avif": 79990,
	"./articles/open-thread.avif": 71019,
	"./articles/productivity-increases-ai.jpg": 86241,
	"./articles/time-taken-decreases.jpg": 77377,
	"./articles/tiny-chef.avif": 28550,
	"./articles/transcript.avif": 62581,
	"./behind-advante.webp": 66143,
	"./bgr-multicolor-flat.webp": 81102,
	"./bgr-multicolor-large.webp": 95132,
	"./bgr-multicolor-small.webp": 72660,
	"./bgr-software-service.webp": 61504,
	"./bridgewater/bridge-landing2.webp": 67293,
	"./bridgewater/challenge-app.webp": 73916,
	"./bridgewater/development-bg.webp": 86086,
	"./bridgewater/features.webp": 2468,
	"./bridgewater/header-img.webp": 9666,
	"./bridgewater/phone-app1.webp": 25807,
	"./bridgewater/phone-app2.webp": 40547,
	"./caseStudies/ANS-1.webp": 34933,
	"./caseStudies/ANS-2.webp": 66702,
	"./caseStudies/ANS-3.webp": 29179,
	"./caseStudies/Aflac-1.webp": 70603,
	"./caseStudies/Aflac-2.webp": 60559,
	"./caseStudies/Aflac-3.webp": 51767,
	"./caseStudies/Ameritrade-1.webp": 88899,
	"./caseStudies/Ameritrade-2.webp": 17379,
	"./caseStudies/Ameritrade-3.webp": 21135,
	"./caseStudies/Bajibot-1.webp": 16069,
	"./caseStudies/Bajibot-2.webp": 70216,
	"./caseStudies/Bajibot-3.webp": 48015,
	"./caseStudies/BodyArmor-1.webp": 78410,
	"./caseStudies/BodyArmor-2.webp": 39694,
	"./caseStudies/BodyArmor-3.webp": 27019,
	"./caseStudies/Bridgewater-1.webp": 18747,
	"./caseStudies/Bridgewater-2.webp": 81270,
	"./caseStudies/Bridgewater-3.webp": 44481,
	"./caseStudies/BuffaloTrace-1.webp": 28626,
	"./caseStudies/BuffaloTrace-2.webp": 92768,
	"./caseStudies/BuffaloTrace-3.webp": 64992,
	"./caseStudies/Chicago-1.webp": 32177,
	"./caseStudies/Chicago-2.webp": 14455,
	"./caseStudies/ComputerAES.webp": 55276,
	"./caseStudies/ComputerANS.webp": 49510,
	"./caseStudies/ComputerAflac.webp": 21807,
	"./caseStudies/ComputerBajibot.webp": 56934,
	"./caseStudies/ComputerBernzomatic.webp": 32623,
	"./caseStudies/ComputerBodyArmor.webp": 59622,
	"./caseStudies/ComputerBridgewater.webp": 87297,
	"./caseStudies/ComputerBuffaloTrace.webp": 51007,
	"./caseStudies/ComputerChicago.webp": 79631,
	"./caseStudies/ComputerCoronet.webp": 74550,
	"./caseStudies/ComputerDavidOrtiz.webp": 46814,
	"./caseStudies/ComputerDigitalLife.webp": 83854,
	"./caseStudies/ComputerEaglesFC.webp": 47299,
	"./caseStudies/ComputerFriendsoftheLake.webp": 26144,
	"./caseStudies/ComputerHulu.webp": 19039,
	"./caseStudies/ComputerJudigoLegal.webp": 30988,
	"./caseStudies/ComputerManeeAddicts.webp": 91139,
	"./caseStudies/ComputerNutiva.webp": 57038,
	"./caseStudies/ComputerPlanutGoods.webp": 12038,
	"./caseStudies/ComputerRowdy.webp": 15701,
	"./caseStudies/ComputerSPA.webp": 99142,
	"./caseStudies/ComputerSeagrams.webp": 98344,
	"./caseStudies/ComputerSixPlusOne.webp": 51474,
	"./caseStudies/ComputerSprout.webp": 25299,
	"./caseStudies/ComputerStafWizard.webp": 83700,
	"./caseStudies/ComputerSynchrony.webp": 31460,
	"./caseStudies/ComputerimposibleEscape.webp": 70759,
	"./caseStudies/DigitalLife-1.webp": 11106,
	"./caseStudies/DigitalLife-2.webp": 21222,
	"./caseStudies/DigitalLife-3.webp": 76763,
	"./caseStudies/EagleFC-1.webp": 98121,
	"./caseStudies/EagleFC-2.webp": 70648,
	"./caseStudies/EagleFC-3.webp": 30084,
	"./caseStudies/Friends-1.webp": 27694,
	"./caseStudies/Friends-2.webp": 4410,
	"./caseStudies/Friends-3.webp": 90095,
	"./caseStudies/Hulu-1.webp": 20052,
	"./caseStudies/Hulu-2.webp": 46275,
	"./caseStudies/Hulu-3.webp": 18519,
	"./caseStudies/ImpossibleEscape-1.webp": 34665,
	"./caseStudies/ImpossibleEscape-2.webp": 12226,
	"./caseStudies/ImpossibleEscape-3.webp": 4311,
	"./caseStudies/ManeAddicts-1.webp": 37020,
	"./caseStudies/ManeAddicts-2.webp": 99272,
	"./caseStudies/ManeAddicts-3.webp": 87584,
	"./caseStudies/MySpa-1.webp": 49279,
	"./caseStudies/MySpa-2.webp": 21727,
	"./caseStudies/MySpa-3.webp": 70114,
	"./caseStudies/Nutiva-1.webp": 88879,
	"./caseStudies/Nutiva-2.webp": 21739,
	"./caseStudies/Nutiva-3.webp": 59698,
	"./caseStudies/PhoneiBird.webp": 29056,
	"./caseStudies/PlanutGood-1.webp": 41216,
	"./caseStudies/PlanutGood-2.webp": 545,
	"./caseStudies/PlanutGood-3.webp": 86777,
	"./caseStudies/SixPlusOne-1.webp": 93732,
	"./caseStudies/SixPlusOne-2.webp": 13268,
	"./caseStudies/SixPlusOne-3.webp": 60521,
	"./caseStudies/StaffWizard-1.webp": 51335,
	"./caseStudies/StaffWizard-2.webp": 33160,
	"./caseStudies/StaffWizard-3.webp": 35853,
	"./caseStudies/Synchrony-1.webp": 67805,
	"./caseStudies/Synchrony-2.webp": 8730,
	"./caseStudies/Synchrony-3.webp": 49484,
	"./caseStudies/aes-1.webp": 39008,
	"./caseStudies/aes-2.webp": 97196,
	"./caseStudies/aes-3.webp": 78397,
	"./caseStudies/bernzomatic-1.webp": 15680,
	"./caseStudies/bernzomatic-2.webp": 11047,
	"./caseStudies/coronet-1.webp": 99354,
	"./caseStudies/coronet-2.webp": 60404,
	"./caseStudies/coronet-3.webp": 52238,
	"./caseStudies/david-1.webp": 57826,
	"./caseStudies/david-2.webp": 68357,
	"./caseStudies/david-3.webp": 62867,
	"./caseStudies/ibird-1.webp": 79981,
	"./caseStudies/ibird-2.webp": 7225,
	"./caseStudies/ibird-3.webp": 49857,
	"./caseStudies/judigo-1.webp": 54244,
	"./caseStudies/judigo-2.webp": 1884,
	"./caseStudies/judigo-3.webp": 68603,
	"./caseStudies/peachy-1.webp": 86006,
	"./caseStudies/peachy-2.webp": 84773,
	"./caseStudies/phoneAmeritrade.webp": 47578,
	"./caseStudies/phonePeachy.webp": 15321,
	"./caseStudies/rowdy-1.webp": 87777,
	"./caseStudies/rowdy-2.webp": 49758,
	"./caseStudies/rowdy-3.webp": 22046,
	"./caseStudies/seagrams-1.webp": 42133,
	"./caseStudies/seagrams-2.webp": 15849,
	"./caseStudies/seagrams-3.webp": 26816,
	"./caseStudies/sprout-1.webp": 12084,
	"./caseStudies/sprout-2.webp": 22417,
	"./caseStudies/sprout-3.webp": 59722,
	"./cases/background-case-design.webp": 33429,
	"./cases/background-case-e-commerce.webp": 45217,
	"./cases/bgr-multicolor-flat.webp": 16015,
	"./cases/bgr-multicolor-large.webp": 44012,
	"./cases/case-01.webp": 17007,
	"./cases/case-02.webp": 76882,
	"./cases/case-03.webp": 69562,
	"./cases/case-04.webp": 65333,
	"./cases/case-05.webp": 82590,
	"./cases/case-06.webp": 75775,
	"./cases/case-07.webp": 31106,
	"./cases/case-08.webp": 36131,
	"./cases/case-09.webp": 7735,
	"./cases/case-10.webp": 2145,
	"./cases/case-13.webp": 30049,
	"./cases/case-14.webp": 73545,
	"./close.svg": 94167,
	"./collaborations-group-1.png": 80852,
	"./collaborations-group-2.png": 91190,
	"./credit-card-base.webp": 19214,
	"./credit-card-effect.webp": 79280,
	"./credit-card-group.webp": 80716,
	"./development-setup.webp": 31473,
	"./dots-bgr.png": 4921,
	"./double-underline.svg": 15273,
	"./e-commerce/background-case-e-commerce.webp": 76109,
	"./e-commerce/bgr-e-commerce.webp": 43729,
	"./events/event-25.jpg": 96555,
	"./events/event-25.webp": 56641,
	"./events/event-26.jpg": 82283,
	"./events/event-26.webp": 30428,
	"./events/event-27.jpg": 55432,
	"./events/event-27.webp": 85226,
	"./events/event-28.jpg": 64631,
	"./events/event-28.webp": 25977,
	"./events/event-29.jpg": 19297,
	"./events/event-29.webp": 73734,
	"./events/event-30.jpg": 15277,
	"./events/event-30.webp": 21017,
	"./events/event-31.jpg": 57054,
	"./events/event-31.webp": 89820,
	"./events/event-32.jpg": 47748,
	"./events/event-32.webp": 25072,
	"./events/event-33.jpg": 58614,
	"./events/event-33.webp": 31695,
	"./events/event-34.jpg": 38745,
	"./events/event-34.webp": 14442,
	"./events/event-35.jpg": 65975,
	"./events/event-35.webp": 23445,
	"./events/event-36.jpg": 77604,
	"./events/event-36.webp": 44925,
	"./events/event-37.jpg": 68817,
	"./events/event-37.webp": 86718,
	"./events/event-38.jpg": 66552,
	"./events/event-38.webp": 64010,
	"./events/event-39.jpg": 38341,
	"./events/event-39.webp": 57265,
	"./events/event-40.jpg": 64617,
	"./events/event-40.webp": 3414,
	"./events/event-41.jpg": 8656,
	"./events/event-41.webp": 87629,
	"./events/event-42.jpg": 34924,
	"./events/event-42.webp": 19652,
	"./graphic-design-technologies/logo-adobe-ae.webp": 37416,
	"./graphic-design-technologies/logo-adobe-ai.webp": 19521,
	"./graphic-design-technologies/logo-adobe-ps.webp": 62153,
	"./graphic-design-technologies/logo-balsamiq-box.webp": 31295,
	"./graphic-design-technologies/logo-balsamiq.webp": 71285,
	"./graphic-design-technologies/logo-blender.webp": 3174,
	"./graphic-design-technologies/logo-canva.webp": 76564,
	"./graphic-design-technologies/logo-coreldraw.webp": 89085,
	"./graphic-design-technologies/logo-eraserio-box.webp": 62677,
	"./graphic-design-technologies/logo-excalidraw-box.webp": 46201,
	"./graphic-design-technologies/logo-excalidraw.webp": 30190,
	"./graphic-design-technologies/logo-figma-box.webp": 7333,
	"./graphic-design-technologies/logo-figma.webp": 30905,
	"./graphic-design-technologies/logo-invision.webp": 80590,
	"./graphic-design-technologies/logo-procreate.webp": 14463,
	"./guy-vr-interactive.webp": 77314,
	"./healthcare-case.webp": 88180,
	"./ia-robohands-header.webp": 14031,
	"./ico-brainstorm.webp": 72677,
	"./ico-collect.webp": 91438,
	"./ico-elements.webp": 68303,
	"./ico-launch.webp": 24088,
	"./ico-research.webp": 6800,
	"./ico-service-design-art.webp": 76448,
	"./ico-service-design-branding.webp": 24367,
	"./ico-service-design-design.webp": 54062,
	"./ico-service-design-wireframing.webp": 26763,
	"./ico-testing.webp": 66422,
	"./ico-uxuidesign.webp": 71584,
	"./ico-wireframing.webp": 76485,
	"./icons/ico-bag.png": 70182,
	"./icons/ico-bag.svg": 21370,
	"./icons/ico-bars.svg": 30669,
	"./icons/ico-bulb.svg": 31294,
	"./icons/ico-campaign.png": 5663,
	"./icons/ico-campaing.svg": 54749,
	"./icons/ico-chip.svg": 169,
	"./icons/ico-flask.svg": 68385,
	"./icons/ico-hammer.png": 90755,
	"./icons/ico-hammer.svg": 90584,
	"./icons/ico-heart.png": 62223,
	"./icons/ico-heart.svg": 57424,
	"./icons/ico-lens.svg": 48046,
	"./icons/ico-mountain.svg": 75892,
	"./icons/ico-people.svg": 67307,
	"./icons/ico-puzzle.png": 99082,
	"./icons/ico-puzzle.svg": 78508,
	"./icons/ico-stadistics.svg": 36351,
	"./icons/ico-statistics.png": 80935,
	"./icons/ico-store.png": 51380,
	"./icons/ico-store.svg": 7255,
	"./icons/ico-stroke-architecture.png": 23229,
	"./icons/ico-stroke-cases.png": 38851,
	"./icons/ico-stroke-cube.png": 64105,
	"./icons/ico-stroke-flow.png": 23703,
	"./icons/ico-stroke-microservices.png": 37638,
	"./icons/ico-stroke-trees.png": 61379,
	"./icons/ico-wallet.svg": 23014,
	"./industry/digital-payment.webp": 73678,
	"./industry/e-commerce-software.jpg": 54124,
	"./industry/e-commerce-software.webp": 86106,
	"./industry/finance-payment.webp": 30846,
	"./industry/finance-software.jpg": 43629,
	"./industry/finance-software.webp": 55934,
	"./industry/healthcare-payment.webp": 24425,
	"./industry/healthcare-software.jpg": 26247,
	"./industry/healthcare-software.webp": 32583,
	"./industry/hhrr-payment.webp": 87189,
	"./industry/law-payment.webp": 34836,
	"./industry/legal-issues-software.jpg": 454,
	"./industry/legal-issues-software.webp": 9819,
	"./industry/marketplaces-software.jpg": 51364,
	"./industry/marketplaces-software.webp": 69640,
	"./industry/retail-payment.webp": 9032,
	"./industry/startups-payment.webp": 85596,
	"./judigo-legal/access.webp": 6826,
	"./judigo-legal/css.webp": 97247,
	"./judigo-legal/expansion.webp": 21921,
	"./judigo-legal/grad1.webp": 90337,
	"./judigo-legal/grad2.webp": 58818,
	"./judigo-legal/html.webp": 26155,
	"./judigo-legal/java.webp": 63488,
	"./judigo-legal/js.webp": 39435,
	"./judigo-legal/js2.webp": 78700,
	"./judigo-legal/judigo-phone.webp": 93397,
	"./judigo-legal/lines.webp": 63960,
	"./judigo-legal/php.webp": 4,
	"./judigo-legal/technical.webp": 15634,
	"./judigo-legal/time-sensitive.webp": 38670,
	"./judigo-legal/title.webp": 40804,
	"./key-symbol.svg": 74048,
	"./logo-clients/aflac.png": 3152,
	"./logo-clients/bajibot.png": 40290,
	"./logo-clients/bernzomatic.png": 84911,
	"./logo-clients/bodyarmor.png": 95399,
	"./logo-clients/bridgewater.png": 7330,
	"./logo-clients/buffalotrace.png": 90775,
	"./logo-clients/coronet.png": 36727,
	"./logo-clients/crackerbarrel.png": 22184,
	"./logo-clients/davidortiz.png": 13511,
	"./logo-clients/fotl.png": 51551,
	"./logo-clients/hulu.png": 28492,
	"./logo-clients/maneaddicts.png": 56155,
	"./logo-clients/myspalive.png": 12203,
	"./logo-clients/nbc.png": 48750,
	"./logo-clients/nutiva.png": 21400,
	"./logo-clients/peachy.png": 44936,
	"./logo-clients/planut.png": 15041,
	"./logo-clients/robertmarc.png": 58454,
	"./logo-clients/rowdy.png": 98634,
	"./logo-clients/sarais.png": 84615,
	"./logo-clients/seagrams.png": 57771,
	"./logo-clients/sixplusone.png": 51516,
	"./logo-clients/staffwizard.png": 52433,
	"./logo-clients/syfy.png": 52749,
	"./logo-clients/synchrony.png": 39193,
	"./logo-clients/twsj.png": 18638,
	"./logo-clients2/aflac.webp": 15150,
	"./logo-clients2/bajibot.webp": 31682,
	"./logo-clients2/bernzomatic.webp": 48083,
	"./logo-clients2/bodyarmor.webp": 2052,
	"./logo-clients2/bridgewater.webp": 46044,
	"./logo-clients2/buffalotrace.webp": 74941,
	"./logo-clients2/coronet.webp": 62198,
	"./logo-clients2/crackerbarrel.webp": 29195,
	"./logo-clients2/davidortiz.webp": 33899,
	"./logo-clients2/fotl.webp": 735,
	"./logo-clients2/hulu.webp": 95545,
	"./logo-clients2/maneaddicts.webp": 251,
	"./logo-clients2/myspalive.webp": 84440,
	"./logo-clients2/nbc.webp": 66237,
	"./logo-clients2/nutiva.webp": 16218,
	"./logo-clients2/peachy.webp": 31213,
	"./logo-clients2/planut.webp": 77873,
	"./logo-clients2/robertmarc.webp": 69330,
	"./logo-clients2/rowdy.webp": 64050,
	"./logo-clients2/sarais.webp": 16951,
	"./logo-clients2/seagrams.webp": 83481,
	"./logo-clients2/sixplusone.webp": 42209,
	"./logo-clients2/staffwizard.webp": 77301,
	"./logo-clients2/syfy.webp": 97598,
	"./logo-clients2/synchrony.webp": 10810,
	"./logo-clients2/twsj.webp": 71026,
	"./logo-tech/logo-calendly.webp": 83877,
	"./logo-tech/logo-flutter.webp": 29534,
	"./logo-tech/logo-highlevel.webp": 5236,
	"./logo-tech/logo-mailchimp.webp": 2262,
	"./logo-tech/logo-mailgun.webp": 45631,
	"./logo-tech/logo-maps.webp": 3953,
	"./logo-tech/logo-paypal.webp": 69256,
	"./logo-tech/logo-pipedrive.webp": 18071,
	"./logo-tech/logo-quickbooks.webp": 30730,
	"./logo-tech/logo-react.webp": 84321,
	"./logo-tech/logo-roposo.webp": 79402,
	"./logo-tech/logo-shopify.webp": 72618,
	"./logo-tech/logo-stripe.webp": 73161,
	"./logo-tech/logo-twilio.webp": 21483,
	"./logo-tech/logo-woo.webp": 94072,
	"./logo-tech/logo-zoom.webp": 77062,
	"./logo-technologies/logo-calendly.webp": 48854,
	"./logo-technologies/logo-css.webp": 99776,
	"./logo-technologies/logo-flutter.webp": 4882,
	"./logo-technologies/logo-highlevel.webp": 43260,
	"./logo-technologies/logo-html.webp": 81399,
	"./logo-technologies/logo-java.png": 36386,
	"./logo-technologies/logo-java.webp": 15686,
	"./logo-technologies/logo-js.webp": 74384,
	"./logo-technologies/logo-klaviyo.webp": 76874,
	"./logo-technologies/logo-kotlin.webp": 12557,
	"./logo-technologies/logo-mailchimp.webp": 61147,
	"./logo-technologies/logo-mailgun.webp": 91041,
	"./logo-technologies/logo-maps.webp": 12830,
	"./logo-technologies/logo-paypal.webp": 43040,
	"./logo-technologies/logo-php.webp": 83718,
	"./logo-technologies/logo-pipedrive.webp": 63418,
	"./logo-technologies/logo-quickbooks.webp": 43191,
	"./logo-technologies/logo-react.webp": 19688,
	"./logo-technologies/logo-roposo.webp": 24116,
	"./logo-technologies/logo-shopify.webp": 8574,
	"./logo-technologies/logo-stripe.webp": 69369,
	"./logo-technologies/logo-swift.webp": 84974,
	"./logo-technologies/logo-twilio.webp": 62950,
	"./logo-technologies/logo-woo.webp": 81970,
	"./logo-technologies/logo-zoom.webp": 49875,
	"./logo_advante.png": 80781,
	"./logo_advante.webp": 86832,
	"./market-analysis-head-bgr.webp": 77547,
	"./market-analysis/arrow-step-1.png": 55696,
	"./market-analysis/arrow-step-1.svg": 84245,
	"./market-analysis/arrow-step-2.svg": 45164,
	"./market-analysis/arrow-step-3.svg": 5008,
	"./market-analysis/circle-sketch.svg": 42067,
	"./market-analysis/data-collection-img.webp": 29337,
	"./market-analysis/empower-item-1.webp": 13550,
	"./market-analysis/empower-item-2.webp": 9989,
	"./market-analysis/empower-item-3.webp": 63658,
	"./market-analysis/empower-item-4.webp": 72425,
	"./market-analysis/header-image.webp": 46942,
	"./market-analysis/identification-opportunities.webp": 65585,
	"./market-analysis/implementation.webp": 31154,
	"./market-analysis/market-segmentation.webp": 57107,
	"./market-analysis/subline-red-sketch.svg": 37649,
	"./market-arrow.svg": 53186,
	"./menu-advante.svg": 20801,
	"./nois-2e.png": 75287,
	"./noise.png": 10045,
	"./payment-cone.webp": 39970,
	"./payment-cube.webp": 13513,
	"./payment-donut.webp": 2042,
	"./picture-durango.webp": 53018,
	"./picture-newyork.webp": 56660,
	"./rowdy-energy/challenge-ellipse.webp": 56529,
	"./rowdy-energy/fruits.webp": 11784,
	"./rowdy-energy/get-rowdy.webp": 62442,
	"./rowdy-energy/purple-circle.webp": 97095,
	"./rowdy-energy/rowdy-features.webp": 32295,
	"./rowdy-energy/rowdy-landing.webp": 71632,
	"./rowdy-energy/rowdy-outcome.webp": 71960,
	"./rowdy-energy/rowdy-solution.webp": 96107,
	"./seagrams/bottle.webp": 99023,
	"./seagrams/development-wave.webp": 902,
	"./seagrams/features1.webp": 26440,
	"./seagrams/features2.webp": 95774,
	"./seagrams/outcome-app.webp": 26603,
	"./seagrams/seagrams-landing.webp": 75968,
	"./seagrams/seagrams-wave.webp": 42192,
	"./seagrams/solution-wave.webp": 53020,
	"./software-layout-2.webp": 2669,
	"./software-layout-bottom.webp": 26255,
	"./software-layout.webp": 30916,
	"./solutions/ico-01-2.webp": 33493,
	"./solutions/ico-01.svg": 92822,
	"./solutions/ico-02-2.webp": 89265,
	"./solutions/ico-02.svg": 899,
	"./solutions/ico-025-1.svg": 9507,
	"./solutions/ico-025-3.svg": 6439,
	"./solutions/ico-026-1.svg": 44483,
	"./solutions/ico-026-3.svg": 22209,
	"./solutions/ico-027-1.svg": 78302,
	"./solutions/ico-027-3.svg": 95021,
	"./solutions/ico-03-2.webp": 36160,
	"./solutions/ico-03.svg": 25808,
	"./solutions/ico-04-2.webp": 58249,
	"./solutions/ico-04.svg": 49178,
	"./solutions/ico-05-2.webp": 63228,
	"./solutions/ico-05.svg": 67438,
	"./solutions/ico-06-2.webp": 60180,
	"./solutions/ico-06.svg": 57773,
	"./solutions/ico-07-2.webp": 75537,
	"./solutions/ico-07.svg": 52962,
	"./solutions/ico-08-2.webp": 31441,
	"./solutions/ico-08.svg": 87255,
	"./solutions/ico-09-2.webp": 80875,
	"./solutions/ico-09.svg": 35080,
	"./solutions/ico-10-2.webp": 32549,
	"./solutions/ico-10.svg": 64729,
	"./solutions/ico-11-2.webp": 63048,
	"./solutions/ico-11.svg": 89484,
	"./solutions/ico-12-2.webp": 44237,
	"./solutions/ico-12.svg": 46899,
	"./solutions/ico-13-2.webp": 41639,
	"./solutions/ico-13.svg": 19256,
	"./solutions/ico-14-2.webp": 41899,
	"./solutions/ico-14.svg": 74501,
	"./solutions/ico-15-2.webp": 77092,
	"./solutions/ico-15.svg": 72200,
	"./solutions/ico-16-2.webp": 59041,
	"./solutions/ico-16.svg": 65170,
	"./solutions/ico-17-2.webp": 66773,
	"./solutions/ico-17.svg": 93463,
	"./solutions/ico-18-2.webp": 83042,
	"./solutions/ico-18.svg": 78688,
	"./solutions/ico-19-2.webp": 68734,
	"./solutions/ico-19.svg": 61679,
	"./solutions/ico-20-2.webp": 14499,
	"./solutions/ico-20.svg": 15767,
	"./solutions/ico-21.svg": 74784,
	"./solutions/ico-22.svg": 34364,
	"./solutions/ico-23.svg": 63064,
	"./solutions/ico-24.svg": 71568,
	"./solutions/ico-25.svg": 6357,
	"./solutions/ico-26.svg": 6325,
	"./solutions/ico-27.svg": 75850,
	"./solutions/ico-28.svg": 84957,
	"./solutions/ico-29.svg": 21008,
	"./solutions/ico-30.svg": 58985,
	"./solutions/ico-31.svg": 86395,
	"./solutions/ico-32.svg": 61035,
	"./solutions/ico-33.svg": 55287,
	"./solutions/ico-34.svg": 82841,
	"./solutions/ico-35.svg": 27417,
	"./solutions/ico-36.svg": 55231,
	"./solutions/image-01.webp": 88348,
	"./solutions/image-02.webp": 90876,
	"./solutions/image-03.webp": 12578,
	"./solutions/image-04.webp": 47675,
	"./solutions/image-05.webp": 6467,
	"./solutions/image-06.webp": 1045,
	"./solutions/image-07.webp": 58923,
	"./solutions/image-08.webp": 4277,
	"./solutions/image-09.webp": 26303,
	"./solutions/image-10.webp": 53953,
	"./solutions/image-11.webp": 34471,
	"./solutions/image-12.webp": 40358,
	"./solutions/image-13.webp": 46541,
	"./solutions/image-14.webp": 22792,
	"./solutions/image-15.webp": 87906,
	"./solutions/image-16.webp": 59913,
	"./solutions/image-17.webp": 40,
	"./solutions/image-18.webp": 50826,
	"./spa-live/design-bg.webp": 51962,
	"./spa-live/design-img.webp": 25679,
	"./spa-live/development-bg.webp": 20078,
	"./spa-live/development-img.webp": 47295,
	"./spa-live/evaluation-bg.webp": 24190,
	"./spa-live/evaluation-img.webp": 50764,
	"./spa-live/grad1.webp": 38016,
	"./spa-live/grad2.webp": 47539,
	"./spa-live/grad3.webp": 89158,
	"./spa-live/implementation-bg.webp": 20664,
	"./spa-live/implementation-img.webp": 17246,
	"./spa-live/phone-spa.webp": 7718,
	"./spa-live/planning-bg.webp": 93517,
	"./spa-live/planning-img.webp": 1125,
	"./spa-live/planning-img1.webp": 50531,
	"./spa-live/technologies.webp": 87792,
	"./staffwizard/approach.webp": 40779,
	"./staffwizard/gradient.webp": 49581,
	"./staffwizard/innovation.webp": 76892,
	"./staffwizard/line.webp": 55672,
	"./staffwizard/staff-solutions.webp": 52227,
	"./staffwizard/staffPanel.webp": 23692,
	"./svg/AdvanteLogo": 91468,
	"./svg/AdvanteLogo.jsx": 91468,
	"./svg/IcoArrowThin": 80599,
	"./svg/IcoArrowThin.jsx": 80599,
	"./svg/IcoBasketSmile": 81570,
	"./svg/IcoBasketSmile.jsx": 81570,
	"./svg/IcoCalendarDollar": 36806,
	"./svg/IcoCalendarDollar.jsx": 36806,
	"./svg/IcoCheckoutLocation": 27299,
	"./svg/IcoCheckoutLocation.jsx": 27299,
	"./svg/IcoEcommerce": 62895,
	"./svg/IcoEcommerce.jsx": 62895,
	"./svg/IcoMobileBill": 27045,
	"./svg/IcoMobileBill.jsx": 27045,
	"./svg/IcoPlatformIntegrations": 4120,
	"./svg/IcoPlatformIntegrations.jsx": 4120,
	"./svg/IcoSocialFacebook": 57921,
	"./svg/IcoSocialFacebook.jsx": 57921,
	"./svg/IcoSocialInstagram": 45494,
	"./svg/IcoSocialInstagram.jsx": 45494,
	"./svg/IcoSocialLinkedin": 78384,
	"./svg/IcoSocialLinkedin.jsx": 78384,
	"./svg/IcoSocialTwitter": 86902,
	"./svg/IcoSocialTwitter.jsx": 86902,
	"./svg/IcoSoftwareDevelopment": 63312,
	"./svg/IcoSoftwareDevelopment.jsx": 63312,
	"./svg/bgr-bean.svg": 32554,
	"./svg/circle-sketch.svg": 25251,
	"./svg/design-A.svg": 31559,
	"./svg/ico-artificial-intelligence.svg": 79546,
	"./svg/ico-basket-smile.svg": 38894,
	"./svg/ico-calendar-dollar.svg": 8562,
	"./svg/ico-checkout-location.svg": 40120,
	"./svg/ico-clock.svg": 87828,
	"./svg/ico-digital-marketing.svg": 78279,
	"./svg/ico-e-commerce.svg": 43697,
	"./svg/ico-graphic-design.svg": 28586,
	"./svg/ico-location.svg": 99460,
	"./svg/ico-market-analysis.svg": 85782,
	"./svg/ico-mobile-bill.svg": 88381,
	"./svg/ico-payments-solutions.svg": 46222,
	"./svg/ico-plataform-integrations.svg": 65771,
	"./svg/ico-software-development-scale.svg": 72085,
	"./svg/ico-software-development.svg": 43654,
	"./svg/ico-software-product-design.svg": 94270,
	"./svg/star-testimonial.svg": 95824,
	"./svg/union-grid-full.svg": 38557,
	"./tag-symbol.svg": 6951,
	"./team/alan.webp": 99157,
	"./team/alexis.webp": 83874,
	"./team/alma.webp": 94998,
	"./team/alonso.webp": 36927,
	"./team/antonio.webp": 13990,
	"./team/aric.webp": 73559,
	"./team/atzael.webp": 9506,
	"./team/brian.webp": 97051,
	"./team/carlos-fernando.webp": 43345,
	"./team/claudio.webp": 29025,
	"./team/cory.webp": 75334,
	"./team/eduardo.webp": 5857,
	"./team/emmanuel.webp": 46096,
	"./team/enrique.webp": 27834,
	"./team/felipe.webp": 60860,
	"./team/francisco-freyre.webp": 40180,
	"./team/hugo.webp": 78141,
	"./team/joel.webp": 69028,
	"./team/jorge-lara.webp": 75973,
	"./team/jorge-puente.webp": 52468,
	"./team/josue.webp": 15058,
	"./team/leo.webp": 96421,
	"./team/luis-fraire.webp": 57545,
	"./team/luis.webp": 52153,
	"./team/manuel.webp": 91517,
	"./team/marce.webp": 36849,
	"./team/mauro.webp": 13428,
	"./team/max.webp": 36851,
	"./team/meni.webp": 71456,
	"./team/omar.webp": 63924,
	"./team/paola.webp": 34093,
	"./team/ramon.webp": 33672,
	"./team/saul.webp": 86038,
	"./terminal-c.webp": 46837,
	"./terminal-html.webp": 80169,
	"./terminal-java.webp": 64760,
	"./union-grid.webp": 78660,
	"./wave-1.svg": 42559,
	"./wave-2.svg": 69354,
	"./wave-3.svg": 90658,
	"./x-bgr.png": 17708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96303;